








































import AbpBase from "@/lib/abpbase";
import { Component, Prop } from "vue-property-decorator";
import { QueryTeamPagedList, DeleteTeam } from "@/api/pdTeam/index";
import TeamDetail from "./detail.vue";
import TeamUser from "./teamUser.vue";
import TeamVillage from "./teamVillage.vue";

/**
 * 团队管理
 */
@Component({
    components: {
        TeamDetail,
        TeamUser,
        TeamVillage
    }
})
export default class Team extends AbpBase {
    data: any[] = [];
    loading: boolean = false;
    tableTotalSize: number = 0;
    showDetail: boolean = false;
    showTeamUser: boolean = false;
    showTeamVillage: boolean = false;
    currentTeam: any = {};

    queryCondition: any = {
        QueryString: "",
        SkipCount: 1,
        MaxResultCount: 10,
        SortKey: "id",
        SortOrder: "asc",
        LoginUserName: "",
        LoginUserCommunityId: 0
    };

    columns = [
        {
            key: "code",
            width: 150,
            title: "团队编码"
        },
        {
            key: "name",
            title: "团队名称"
        },
        {
            key: "communityName",
            title: "所属社区"
        },
        {
            key: "",
            width: 320,
            title: "操作",
            render: (h: any, p: any) => {
                return h("div", [
                    h(
                        "Button",
                        {
                            props: { type: "primary", size: "small" },
                            style: { marginRight: "5px" },
                            on: {
                                click: () => {
                                    this.handleUpdateTeam(p.row);
                                }
                            }
                        },
                        "编辑"
                    ),
                    h(
                        "Button",
                        {
                            props: { type: "error", size: "small" },
                            style: { marginRight: "5px" },
                            on: {
                                click: (event: any) => {
                                    this.handleDeleteTeam(p.row);
                                }
                            }
                        },
                        "删除"
                    ),
                    h(
                        "Button",
                        {
                            props: { type: "error", size: "small" },
                            style: { marginRight: "5px" },
                            on: {
                                click: (event: any) => {
                                    this.handleTeamMember(p.row);
                                }
                            }
                        },
                        "成员维护"
                    ),
                    h(
                        "Button",
                        {
                            props: { type: "error", size: "small" },
                            style: { marginRight: "5px" },
                            on: {
                                click: (event: any) => {
                                    this.handleTeamVillage(p.row);
                                }
                            }
                        },
                        "小区维护"
                    )
                ]);
            }
        }
    ];

    handleInsertTeam() {
        this.currentTeam = { id: 0 };
        this.showDetail = true;
    }

    handleUpdateTeam(row: any) {
        this.currentTeam = row;
        this.showDetail = true;
    }

    handleDeleteTeam(row: any) {
        this.$Modal.confirm({
            title: this.L("Tips"),
            content: "确定要删除此团队吗？",
            onOk: async () => {
                await DeleteTeam(row.id);
                this.getData();
            }
        });
    }

    handleTeamMember(row: any) {
        this.currentTeam = row;
        this.showTeamUser = true;
    }

    handleTeamVillage(row: any) {
        this.currentTeam = row;
        this.showTeamVillage = true;
    }

    handleTeamVillageOk() {
        this.$refs.TeamVillage.submit();
        this.showTeamVillage = false;
    }

    async getData() {
        if (this.$store.state.session.user) {
            this.queryCondition.LoginUserName = this.$store.state.session.user.userName;
            this.queryCondition.LoginUserCommunityId = this.$store.state.session.user.communityId;
            this.loading = true;
            let res = await QueryTeamPagedList(this.queryCondition);
            this.data = res.items;
            this.tableTotalSize = res.totalCount;
            this.loading = false;
        }
    }

    handlePageChange(val: any) {
        this.queryCondition.SkipCount = val;
        this.getData();
    }

    handleOk() {
        this.loading = true;
        this.$refs.TeamDetail.submit().then(res => {
            if (res) {
                this.showDetail = false;
                this.getData();
            }
            this.loading = false;
        });
    }

    handleTeamUserOk() {
        this.$refs.TeamUser.submit();
        this.showTeamUser = false;
    }

    created() {
        this.getData();
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/setting/team/index.vue